<div class="scf-payment-detail-page">
    <ng-template #filtersForm>
        <div class="payments-header-right">
            <form class="payments-filter" [formGroup]="paymentDetailFiltersFormGroup">
                <lsq-input
                    class="invoice-search"
                    i18n-placeholder
                    placeholder="Search Invoice Number"
                    formControlName="search"
                    [name]="'search'"
                    [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                    [group]="paymentDetailFiltersFormGroup"
                >
                </lsq-input>

                <lsq-multi-select
                    id="supplier-filter"
                    [options]="supplierFilterOptions"
                    [formControlName]="'supplierFilter'"
                    [group]="paymentDetailFiltersFormGroup"
                    [selectAllText]="allSuppliers"
                    [placeholder]="selectSupplier"
                    [hideLabel]="true"
                    [initializeWithAllSelected]="true"
                >
                </lsq-multi-select>

                <lsq-export-button
                    *ngIf="!(responsiveService.mdBelow | async)"
                    [request]="dataSource.request"
                    [service]="
                        (isBuyerAccountPaymentsPageOn$ | async)
                            ? getAccountPaymentExportService
                            : getPaymentExportService
                    "
                    [reportName]="(reportName$ | async) || 'Payment_Detail'"
                    [isIcon]="true"
                    [disabled]="
                        (dataSource.rows$ | async | notNull)?.length == 0 ||
                        (dataSource.loading$ | async | notNull)
                    "
                ></lsq-export-button>
            </form>
        </div>
    </ng-template>

    <page-header
        [titleText]="
            (payLater$ | async)
                ? payLaterTitle
                : isPaymentOnTerms
                ? invoiceTermsTitle
                : earlyPaymentTitle
        "
        i18n-backButtonText
        backButtonText="back"
        (handleBackButtonClick)="navigateBack()"
    ></page-header>

    <div class="container-fluid page-container">
        <div *ngIf="!isSummaryLoaded">
            <lsq-circle-loader></lsq-circle-loader>
        </div>

        <div class="tables-section" *ngIf="isSummaryLoaded">
            <div class="total-card-section">
                <card
                    i18n-headerTitle
                    headerTitle="Payment Summary"
                    *ngIf="!(responsiveService.mdBelow | async)"
                >
                    <div card-body class="payment-summary-table">
                        <lsq-data-table
                            [hasHeader]="true"
                            [dataSource]="summaryDataSource"
                            [isPaginated]="false"
                            [layoutFixed]="true"
                            [columnVisibilities]="{
                                paymentAmount:
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType !== earlyPaymentType,
                                invoiceAmount:
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === earlyPaymentType,
                                recipient: !(payLater$ | async),
                                paymentType: !(payLater$ | async),
                                buyerAmountPaidToLsq:
                                    !(
                                        (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                            ?.payer === payerLSQ &&
                                        (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                            ?.paymentType === earlyPaymentType
                                    ) &&
                                    !(
                                        (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                            ?.payer === payerLSQ &&
                                        (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                            ?.paymentType === payLaterPaymentType
                                    ) &&
                                    (payLater$ | async),
                                buyerAmountPaidToSupplier:
                                    !(
                                        (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                            ?.payer === payerLSQ &&
                                        (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                            ?.paymentType === earlyPaymentType
                                    ) &&
                                    !(
                                        (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                            ?.payer === payerLSQ &&
                                        (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                            ?.paymentType === payLaterPaymentType
                                    ) &&
                                    (payLater$ | async)
                            }"
                        >
                            <lsq-date-column
                                [column]="{
                                    header: paymentsHeader,
                                    key: 'paymentDate',
                                    width: '12%',
                                    sortable: false
                                }"
                            >
                            </lsq-date-column>

                            <lsq-column
                                [column]="{
                                    header: referenceNumberHeader,
                                    key: 'referenceNumber',
                                    width: '18%',
                                    sortable: false
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    <span
                                        [popover]="row.referenceNumber || undefined"
                                        [popoverDisabled]="
                                            row?.referenceNumber?.length <=
                                            (referenceNumberTruncateAfter$ | async | notNull)
                                        "
                                    >
                                        {{
                                            row.referenceNumber
                                                ? (row.referenceNumber
                                                  | truncateText
                                                      : (referenceNumberTruncateAfter$
                                                            | async
                                                            | notNull)
                                                      : true)
                                                : nullValue
                                        }}
                                    </span>
                                </ng-template>
                            </lsq-column>

                            <lsq-column
                                [column]="{
                                    header: payerHeader,
                                    key: 'payer',
                                    width: '12%',
                                    sortable: false
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    <lsq-smart-truncate [value]="payerTypeDisplay[row.payer]">
                                    </lsq-smart-truncate>
                                </ng-template>
                            </lsq-column>

                            <lsq-column
                                [column]="{
                                    header: recipientHeader,
                                    key: 'recipient',
                                    width: '12%',
                                    sortable: false
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    <lsq-smart-truncate
                                        [value]="buyerPaymentsRecipientDisplayEnum[row.recipient]"
                                    >
                                    </lsq-smart-truncate>
                                </ng-template>
                            </lsq-column>

                            <lsq-column
                                [column]="{
                                    header: typeHeader,
                                    key: 'paymentType',
                                    width: '12%',
                                    sortable: true
                                }"
                            >
                                <ng-template [custom-cell] let-row="row">
                                    {{ buyerPaymentsPaymentTypeDisplayEnum[row.paymentType] }}
                                </ng-template>
                            </lsq-column>

                            <lsq-column
                                [alignRight]="true"
                                [column]="{
                                    header: invoicesHeader,
                                    key: 'numberOfInvoices',
                                    width: '10%',
                                    sortable: false
                                }"
                            >
                            </lsq-column>

                            <lsq-currency-column
                                [column]="{
                                    header: lsqPaymentAmountHeader,
                                    key: 'buyerAmountPaidToLsq',
                                    width: '18%',
                                    sortable: false
                                }"
                            >
                            </lsq-currency-column>

                            <lsq-currency-column
                                [column]="{
                                    header: supplierPaymentAmountHeader,
                                    key: 'buyerAmountPaidToSupplier',
                                    width: '18%',
                                    sortable: false
                                }"
                            >
                            </lsq-currency-column>

                            <lsq-currency-column
                                [column]="{
                                    header: paymentTotalHeader,
                                    key: 'paymentAmount',
                                    width: '10%',
                                    sortable: false
                                }"
                            >
                            </lsq-currency-column>

                            <lsq-currency-column
                                [column]="{
                                    header: invoiceTotalHeader,
                                    width: '10%',
                                    key: 'invoiceAmount',
                                    sortable: false
                                }"
                            >
                            </lsq-currency-column>
                        </lsq-data-table>
                    </div>
                </card>

                <ng-container *ngIf="responsiveService.mdBelow | async">
                    <ng-container *ngTemplateOutlet="filtersForm"></ng-container>
                    <h2 i18n>Payment Summary</h2>
                    <lsq-data-table-mobile
                        [dataSource]="summaryDataSource"
                        [isPaginated]="true"
                        [cardsAreExpandable]="true"
                    >
                        <ng-template #mobileCardHeader let-row="row">
                            <div class="payments-header-mobile">
                                <div class="mtc-header-content-left">
                                    <div class="mtc-header-title">
                                        {{ row.referenceNumber }}
                                    </div>
                                </div>
                                <div class="mtc-header-content-right">
                                    <strong>{{ row.paymentDate | lsqDate: 'shortDate' }}</strong>
                                </div>
                            </div>
                        </ng-template>

                        <ng-template #mobileCardColumns let-row="row">
                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ payerHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ payerTypeDisplay[row.payer] }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ recipientHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ buyerPaymentsRecipientDisplayEnum[row.recipient] }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ typeHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ buyerPaymentsPaymentTypeDisplayEnum[row.paymentType] }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ invoicesHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.numberOfInvoices }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ lsqPaymentAmountHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.buyerAmountPaidToLsq | currencyDash }}
                                </div>
                            </div>

                            <div class="card-item" *ngIf="payLater$ | async">
                                <div class="card-item-label">
                                    {{ supplierPaymentAmountHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.buyerAmountPaidToSupplier | currencyDash }}
                                </div>
                            </div>

                            <div
                                class="card-item"
                                *ngIf="
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType !== earlyPaymentType
                                "
                            >
                                <div class="card-item-label">
                                    {{ paymentTotalHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.paymentAmount | currencyDash }}
                                </div>
                            </div>

                            <div
                                class="card-item"
                                *ngIf="
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === earlyPaymentType
                                "
                            >
                                <div class="card-item-label">
                                    {{ invoiceTotalHeader }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.invoiceAmount | currencyDash }}
                                </div>
                            </div>
                        </ng-template>
                    </lsq-data-table-mobile>
                </ng-container>
            </div>

            <card
                i18n-headerTitle
                headerTitle="Payment Details"
                *ngIf="!(responsiveService.mdBelow | async)"
            >
                <div right-header-content>
                    <ng-container *ngTemplateOutlet="filtersForm"></ng-container>
                </div>
                <div card-body class="payment-details-table">
                    <lsq-data-table
                        [hasHeader]="true"
                        [dataSource]="dataSource"
                        [isPaginated]="true"
                        [layoutFixed]="true"
                        [getRowClassName]="getRowClassNameBound"
                        (skipChanged)="expandedGroupInvoiceKeys.clear()"
                        (takeChanged)="expandedGroupInvoiceKeys.clear()"
                        [columnVisibilities]="{
                            paymentAmount:
                                (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                    ?.paymentType !== earlyPaymentType,
                            numberDaysPaidEarly:
                                (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                    ?.paymentType === earlyPaymentType,
                            buyerFundingChargeTotal:
                                (payLater$ | async) &&
                                !(
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === earlyPaymentType &&
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem?.payer ===
                                        payerLSQ
                                ) &&
                                !(
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === payLaterPaymentType &&
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem?.payer ===
                                        payerLSQ
                                ),
                            earlyPaymentDate: payLater$ | async,
                            payLaterDate:
                                (payLater$ | async) &&
                                !(
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem?.payer ===
                                        payerLSQ &&
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === earlyPaymentType
                                ),
                            recipient: payLater$ | async,
                            buyerFundingChargePaidTotal:
                                (payLater$ | async) &&
                                (dataSource.data$ | async)?.buyerPaymentsSummaryItem?.payer ===
                                    'BUYER',
                            paymentType: payLater$ | async
                        }"
                    >
                        <lsq-column
                            [column]="{
                                key: 'isGroup',
                                width: '4.5rem',
                                sortable: false
                            }"
                        >
                            <ng-template [custom-cell] let-row="row" let-index="index">
                                <div
                                    [class.counter]="!!row.groupedInvoiceKey"
                                    [style.padding-top]="row.isGroup ? 0 : undefined"
                                    [style.padding-bottom]="row.isGroup ? 0 : undefined"
                                >
                                    <ng-container *ngIf="row.isGroup">
                                        <div
                                            class="invoice-group-expand-button"
                                            [attr.tabindex]="0"
                                            (click)="handleInvoiceGroupToggleClick(row)"
                                        >
                                            <lsq-icon
                                                [type]="
                                                    expandedGroupInvoiceKeys.has(row.invoiceKey)
                                                        ? icons.ChevronDown
                                                        : icons.ChevronRight
                                                "
                                                [color]="color.Black"
                                            >
                                            </lsq-icon>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="row.groupedInvoiceKey">
                                        {{
                                            row
                                                | getOffsetIndexOfSiblingRow
                                                    : index
                                                    : 'invoiceKey'
                                                    : 'isGroup'
                                                | async
                                        }}
                                    </ng-container>
                                </div>
                            </ng-template>
                        </lsq-column>
                        <lsq-column
                            [column]="{
                                header: 'Invoice Number',
                                key: 'invoiceNumber',
                                reverseTruncate: true,
                                width: (payLater$ | async) ? '15%' : '30%',
                                onCellClick: goToGroupDetailBound,
                                isClickableFunction: isInvoiceClickableBound,
                                sortable: true,
                                truncateTextCss: true
                            }"
                        >
                        </lsq-column>

                        <lsq-column
                            [column]="{
                                header: supplierHeader,
                                key: 'supplierLegalName',
                                reverseTruncate: true,
                                sortable: true,
                                width: (payLater$ | async) ? '15%' : '30%',
                                truncateTextCss: true
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <a
                                    class="p not-bold supplier-name"
                                    (click)="goSupplierDetails(row.supplierKey)"
                                    queryParamsHandling="preserve"
                                >
                                    <lsq-truncate
                                        [value]="row.supplierLegalName"
                                        [maxLength]="supplierTruncateAfter$ | async | notNull"
                                    ></lsq-truncate>
                                </a>
                            </ng-template>
                        </lsq-column>

                        <lsq-column
                            [column]="{
                                header: typeHeader,
                                key: 'paymentType',
                                sortable: true,
                                width: '15%'
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                {{ getPaymentType(row) }}
                            </ng-template>
                        </lsq-column>

                        <lsq-column
                            [column]="{
                                header: 'Recipient',
                                key: 'recipient',
                                reverseTruncate: true,
                                width: '10%',
                                onCellClick: goToGroupDetailBound,
                                isClickableFunction: isInvoiceClickableBound,
                                sortable: true
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                {{ row.recipient | titlecase }}
                            </ng-template>
                        </lsq-column>

                        <lsq-date-column
                            [column]="{
                                header: invoiceDateHeader,
                                key: 'invoiceDate',
                                width:
                                    (payLater$ | async)
                                        ? (payLater$ | async) &&
                                          (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                              ?.paymentType !== earlyPaymentType
                                            ? '8%'
                                            : '20%'
                                        : '15rem',
                                sortable: true
                            }"
                        >
                        </lsq-date-column>

                        <lsq-date-column
                            [column]="{
                                header: earlyPaymentDateHeader,
                                key: 'earlyPaymentDate',
                                width:
                                    (payLater$ | async) &&
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType !== earlyPaymentType
                                        ? '12%'
                                        : '20%',
                                sortable: true
                            }"
                        >
                        </lsq-date-column>

                        <lsq-date-column
                            [column]="{
                                header: payLaterDateHeader,
                                key: 'payLaterDate',
                                width:
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType !== earlyPaymentType
                                        ? '12%'
                                        : '20%',
                                sortable: true
                            }"
                        >
                        </lsq-date-column>

                        <lsq-column
                            [alignRight]="true"
                            [nullDataDash]="true"
                            [column]="{
                                header: daysPaidHeader,
                                key: 'numberDaysPaidEarly',
                                width: '10%',
                                sortable: true
                            }"
                        >
                        </lsq-column>

                        <lsq-currency-column
                            [column]="{
                                header: invoiceAmountHeader,
                                key: 'invoiceAmount',
                                width:
                                    (payLater$ | async) &&
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType !== earlyPaymentType
                                        ? '10%'
                                        : '20%',
                                sortable: true
                            }"
                        >
                        </lsq-currency-column>

                        <lsq-currency-column
                            [column]="{
                                header: payLaterFeeHeader,
                                key: 'buyerFundingChargeTotal',
                                width: '8%',
                                sortable: true
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                {{
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem?.payer ===
                                    'BUYER'
                                        ? (row.buyerFundingChargeTotal | lsqCurrency)
                                        : (0 | lsqCurrency)
                                }}
                            </ng-template>
                        </lsq-currency-column>

                        <lsq-currency-column
                            [column]="{
                                header: paidFeesAmountHeader,
                                key: 'buyerFundingChargePaidTotal',
                                width: '8%',
                                sortable: true
                            }"
                        >
                        </lsq-currency-column>

                        <lsq-currency-column
                            [column]="{
                                header: paymentAmountHeader,
                                key: 'paymentAmount',
                                width: (payLater$ | async) ? '10%' : '20%',
                                sortable: true
                            }"
                        >
                        </lsq-currency-column>
                    </lsq-data-table>
                </div>
            </card>

            <ng-container *ngIf="responsiveService.mdBelow | async">
                <h2 i18n>Payment Details</h2>
                <lsq-data-table-mobile
                    [dataSource]="dataSource"
                    [isPaginated]="true"
                    [cardsAreExpandable]="true"
                >
                    <ng-template #mobileCardHeader let-row="row">
                        <div class="payments-header-mobile">
                            <div class="mtc-header-content-left">
                                <div class="mtc-header-title">
                                    {{ row.invoiceNumber }}
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #mobileCardColumns let-row="row">
                        <div class="card-item">
                            <div class="card-item-label">
                                {{ supplierHeader }}
                            </div>
                            <div class="card-item-value">
                                <a
                                    class="p not-bold supplier-name"
                                    (click)="goSupplierDetails(row.supplierKey)"
                                    queryParamsHandling="preserve"
                                >
                                    {{ row.supplierLegalName }}
                                </a>
                            </div>
                        </div>

                        <div class="card-item" *ngIf="payLater$ | async">
                            <div class="card-item-label">
                                {{ recipientHeader }}
                            </div>
                            <div class="card-item-value">
                                <a class="p not-bold supplier-name" queryParamsHandling="preserve">
                                    {{ row.recipient }}
                                </a>
                            </div>
                        </div>

                        <div class="card-item" *ngIf="payLater$ | async">
                            <div class="card-item-label">
                                {{ typeHeader }}
                            </div>
                            <div class="card-item-value">
                                {{ row.paymentType }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ invoiceDateHeader }}
                            </div>
                            <div class="card-item-value">
                                {{ row.invoiceDate | lsqDate: 'shortDate' }}
                            </div>
                        </div>

                        <div
                            class="card-item"
                            *ngIf="
                                !(payLater$ | async) &&
                                (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                    ?.paymentType === earlyPaymentType
                            "
                        >
                            <div class="card-item-label">
                                {{ daysPaidHeader }}
                            </div>
                            <div class="card-item-value">
                                {{ row.numberDaysPaidEarly }}
                            </div>
                        </div>

                        <div
                            class="card-item"
                            *ngIf="
                                (payLater$ | async) &&
                                !(
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === earlyPaymentType &&
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem?.payer ===
                                        payerLSQ
                                ) &&
                                !(
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === payLaterPaymentType &&
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem?.payer ===
                                        payerLSQ
                                )
                            "
                        >
                            <div class="card-item-label">
                                {{ payLaterFeeHeader }}
                            </div>
                            <div class="card-item-value">
                                <ng-container
                                    *ngIf="
                                        (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                            ?.payer === 'BUYER';
                                        else zeroCharge
                                    "
                                >
                                    {{ row.buyerFundingChargeTotal | currencyDash }}
                                </ng-container>
                                <ng-template #zeroCharge>{{ 0 | currencyDash }}</ng-template>
                            </div>
                        </div>

                        <div
                            class="card-item"
                            *ngIf="
                                (payLater$ | async) &&
                                !(
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === earlyPaymentType ||
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === invoiceTermType ||
                                    (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                        ?.paymentType === payLaterPaymentType
                                )
                            "
                        >
                            <div class="card-item-label">
                                {{ paidFeesAmountHeader }}
                            </div>
                            <div class="card-item-value">
                                {{ row.buyerFundingChargePaidTotal | currencyDash }}
                            </div>
                        </div>

                        <div class="card-item" *ngIf="payLater$ | async">
                            <div class="card-item-label">
                                {{ earlyPaymentDateHeader }}
                            </div>
                            <div class="card-item-value">
                                {{ row.earlyPaymentDate | lsqDate: 'shortDate' }}
                            </div>
                        </div>

                        <div class="card-item" *ngIf="payLater$ | async">
                            <div class="card-item-label">
                                {{ payLaterDateHeader }}
                            </div>
                            <div class="card-item-value">
                                {{ row.payLaterDate | lsqDate: 'shortDate' }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ invoiceAmountHeader }}
                            </div>
                            <div class="card-item-value">
                                {{ row.invoiceAmount | currencyDash }}
                            </div>
                        </div>

                        <div
                            class="card-item"
                            *ngIf="
                                (dataSource.data$ | async)?.buyerPaymentsSummaryItem
                                    ?.paymentType !== earlyPaymentType
                            "
                        >
                            <div class="card-item-label">
                                {{ paymentAmountHeader }}
                            </div>
                            <div class="card-item-value">
                                {{ row.paymentAmount | currencyDash }}
                            </div>
                        </div>
                    </ng-template>
                    <ng-template #mobileCardFooter let-row="row">
                        <div class="mtc-footer-link" *ngIf="isInvoiceClickableBound(row)">
                            <lsq-button
                                appearance="transparent"
                                (buttonClick)="goToGroupDetailBound(row)"
                                i18n
                            >
                                Invoice Details
                            </lsq-button>
                        </div>
                    </ng-template>
                </lsq-data-table-mobile>
            </ng-container>
        </div>
    </div>
</div>
